import { render, staticRenderFns, recyclableRender, components } from "./mehaotian-search-revision.vue?vue&type=template&id=53d06cc8&"
var renderjs
import script from "./mehaotian-search-revision.vue?vue&type=script&lang=js&"
export * from "./mehaotian-search-revision.vue?vue&type=script&lang=js&"
import style0 from "./mehaotian-search-revision.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../下载/Edge下载/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/mehaotian-search-revision.vue"
export default component.exports